import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, addDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'; // Removed 'toast'
import 'react-toastify/dist/ReactToastify.css';
import './AdminQuotes.css'; // Import custom styles if needed
import Button from './Button'; // Import Button from its file

// Initialize toast notifications

function AdminQuotes({ lang }) {
  const [quotes, setQuotes] = useState([]);
  const [expandedQuoteId, setExpandedQuoteId] = useState(null); // Add state for expanded quote
  const [invoices, setInvoices] = useState(() => JSON.parse(localStorage.getItem('storedInvoices') || '{}'));
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribeQuotes = onSnapshot(collection(db, "quotes"), (snapshot) => {
      const quotesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setQuotes(quotesData);
    });

    return () => unsubscribeQuotes();
  }, []);

  const someFunction = () => {
    // Implement the required functionality
  };

  const handleGenerateInvoice = async (quote) => {
    try {
      const invoiceData = {
        quoteId: quote.id,
        client: quote.name,
        amount: quote.amount,
        date: new Date().toISOString(),
        paymentDue: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString(),
        status: 'Pending'
      };
      await addDoc(collection(db, "invoices"), invoiceData);
      setInvoices(prev => ({ ...prev, [quote.id]: invoiceData }));
      localStorage.setItem('storedInvoices', JSON.stringify({ ...invoices, [quote.id]: invoiceData }));
      navigate('/admin/invoice-dashboard', { state: { invoiceData } });
    } catch (error) {
      console.error("Error generating invoice:", error);
      alert("Failed to generate invoice. Please try again later.");
    }
  };

  return (
    <div className="p-6 bg-gray-50">
      <h1 className="text-3xl font-bold mb-4">{lang === 'th' ? 'จัดการคำขอใบเสนอราคา' : 'Manage Quote Requests'}</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow rounded-lg">
          <thead>
            <tr>
              <th className="py-2 px-4 border-b">{lang === 'th' ? 'รหัสใบเสนอราคา' : 'Quote ID'}</th>
              <th className="py-2 px-4 border-b">{lang === 'th' ? 'ลูกค้า' : 'Client'}</th>
              <th className="py-2 px-4 border-b">{lang === 'th' ? 'จำนวนเงิน' : 'Amount'}</th>
              <th className="py-2 px-4 border-b">{lang === 'th' ? 'สถานะ' : 'Status'}</th>
              <th className="py-2 px-4 border-b">{lang === 'th' ? 'การดำเนินการ' : 'Actions'}</th>
            </tr>
          </thead>
          <tbody>
            {quotes.map((quote, index) => (
              <tr key={quote.id}>
                <td className="py-2 px-4 border-b">#{quote.id.substring(0, 6).toUpperCase()}</td>
                <td className="py-2 px-4 border-b">{quote.name}</td>
                <td className="py-2 px-4 border-b">${quote.amount ? quote.amount.toLocaleString() : '0'}</td>
                <td className="py-2 px-4 border-b">{quote.status}</td>
                <td className="py-2 px-4 border-b">
                  <button
                    onClick={() => handleGenerateInvoice(quote)}
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    {lang === 'th' ? 'สร้างใบแจ้งหนี้' : 'Generate Invoice'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        className="bg-gray-600 hover:bg-gray-500 text-white px-3 py-2 rounded-md"
        onClick={someFunction}
      >
        {lang === "th" ? "ดำเนินการ" : "Proceed"}
      </button>
      <ToastContainer />
    </div>
  );
}

export default AdminQuotes;